// Shared Constants

// Default telemetry state
export const DEFAULT_TELEMETRY = {
    connected: false,
    armed: false,
    mode: 'N/A',
    lat: 0,
    lon: 0,
    alt: 0,
    alt_msl: 0,
    relative_alt: 0,
    alt_raw: 0,
    relative_alt_raw: 0,
    groundspeed: 0,
    airspeed: 0,
    heading: 0,
    battery_voltage: 0,
    battery_remaining: 0,
    battery_current: 0,
    gps_fix: 0,
    satellites: 0,
    roll: 0,
    pitch: 0,
    yaw: 0,
    throttle: 0,
    climbRate: 0,
    wpDist: 0,
    throttle_percent: 0,
};

// Navigation sections
export const SECTIONS = {
    MAP: 'Map',
    MISSIONS: 'Missions',
    DELIVERIES: 'Deliveries',
    DRONES: 'Drones',
    LOGS: 'Logs',
    PROFILE: 'Profile',
    ADMIN: 'Admin',
    SETTINGS: 'Settings',
};

// Default map center (Nagpur, India)
export const DEFAULT_MAP_CENTER = [21.1458, 79.0882];
